import React from 'react';
import Image from 'next/image';
import { Button, Typography } from '@/components/common';
import Images from '@/const/images';
import { TourStepHeader } from '@/components/modals/guided-tour/TourStepHeader';
import { TourStepTracker } from '@/components/modals/guided-tour/TourStepTracker';
import { GuidedTourStepProps } from '@/interfaces';

export const StepYoureAllSet: React.FC<GuidedTourStepProps> = ({
	onClose,
	onBack,
	onFinish,
	currentStep,
	totalSteps,
}) => {
	return (
		<div className="flex flex-col h-full">
			<TourStepHeader onClose={onClose} className="pt-6 md:pt-10">
				<Image src={Images.youAllSet} alt="" width={306} height={296} />
			</TourStepHeader>

			<div className="flex flex-col flex-1 min-h-0 items-center text-center px-5 md:px-10 pt-6 pb-8">
				<Typography
					type="regular-12"
					className="!text-gray-35 uppercase tracking-[0.08em]"
				>
					Step 3 of 3 — You&apos;re set
				</Typography>

				<Typography type="semibold-24" className="mt-2">
					You&apos;re all set
				</Typography>
				<Typography type="semibold-18" className="mt-8">
					Take a look around.
				</Typography>
				<Typography type="regular-18" className="!text-gray-0 mt-3 max-w-lg">
					When you&apos;re ready,{' '}
					<span className="font-semibold text-black">verify your email</span> to
					keep your case moving forward.
				</Typography>

				<div className="flex items-center justify-between w-full mt-auto pt-8">
					<TourStepTracker currentStep={currentStep} totalSteps={totalSteps} />
					<div className="flex items-center gap-3">
						<Button
							decoration="ghost"
							size="fit"
							className="!text-primary !px-2"
							onClick={onBack}
						>
							Back
						</Button>
						<Button
							decoration="primary"
							size="fit"
							className="!px-6 !h-[48px]"
							onClick={onFinish}
						>
							<span className="md:hidden">Dashboard</span>
							<span className="hidden md:inline">Go to your dashboard</span>
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};
